export const PUBLIC_NOTION_URL = 'https://docs.arpeggi.io/faq'
